import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { randomNumber } from 'utils';
import { RelativeDateTime } from 'components';
import {
  changeSelectedStoryIndex,
  setIsStoryLeftOrRightKeyClicked,
  toggleSelectedStories,
} from 'store';
import { UiCheckbox } from 'ui-components';
import { StyledInstagramStoryItem } from './InstagramStoryItem.styles';

const InstagramStoryItem = ({ story, storyIndex, selectable = false }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const selectedStories = useSelector(
    (state) => state.storyReducer.selectedStories
  );

  const handleToggleSelectedStories = (event) => {
    event.stopPropagation();
    dispatch(
      toggleSelectedStories({
        isChecked: event.target.checked,
        selectedStoryId: story?.id,
      })
    );
  };

  const handleClick = () => {
    dispatch(changeSelectedStoryIndex(storyIndex));
    dispatch(setIsStoryLeftOrRightKeyClicked(false));
  };

  // برای اینکه با هر کلیک روی استوری، رنگ اواتار تغییر نکنه
  const rndNumber = useMemo(() => randomNumber(9), []);

  return (
    <StyledInstagramStoryItem>
      <div className='story-item'>
        <div className='story-image' onClick={handleClick}>
          {story?.mediaType === 'image' && <img src={story?.image?.[0]} />}
          {story?.mediaType === 'video' && (
            <video
              width='100%'
              controls
              preload='none'
              poster={story?.image?.[0]}
            >
              <source src={story?.video?.[0]} />
              {t('common:yourBrowserDoesNotSupportTheVideoTag')}
            </video>
          )}

          {selectable && (
            <UiCheckbox
              checked={selectedStories.includes(story?.id)}
              onClick={handleToggleSelectedStories}
            />
          )}
          <div className='story-image-header'>
            <span className='header-username'>
              {story?.username
                ? `@${story?.username}`
                : t('common:instagramNotDetermined')}
            </span>

            {story?.avatar ? (
              <img className='header-avatar' src={story?.avatar} />
            ) : (
              <span className={`header-avatar-text rand-bg-${rndNumber}`}>
                {story?.charAvatar}
              </span>
            )}
          </div>
        </div>
        <div className='story-datetime'>
          <RelativeDateTime dateTime={story?.dateTime} />
        </div>
      </div>
    </StyledInstagramStoryItem>
  );
};

InstagramStoryItem.propTypes = {
  story: PropTypes.object,
  storyIndex: PropTypes.number,
  selectable: PropTypes.bool,
};

export default React.memo(InstagramStoryItem);
